/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unsafe-i18n-at-module-eval */
import I18n from 'I18n';
const I18nInternal = I18n;
export { I18nInternal };